module.exports = __webpack_public_path__ + "img/new.4c340574.gif";